import { Grid, Typography } from "@mui/material"
import { FieldValues, UseFormReturn } from "react-hook-form"
import { ActionCard } from "../../../../../components/widgets/ActionCard";
import { col3 } from "../../../../../common/utils";
import { TruckIcon, WarehouseIcon } from "../../../../../assets/icons";
import { useTranslation } from "react-i18next";



interface Props<T extends FieldValues> {
    form: UseFormReturn<T>;
    handleNext: VoidFunction;
}

export const Category = ({ form, handleNext }: Props<any>) => {

    const { t } = useTranslation("dataCollection");

    const handleSelectCategory = (category: 'transport' | 'consumption') => {
        form.setValue('category', category);
        handleNext();
    }

    return (
        <>
            <Grid size={12}>
                <Typography variant="h5" fontWeight={400} textAlign='center'>
                    {t("import/select category")}
                </Typography>
            </Grid>
            <Grid size={12} container justifyContent="center" spacing={2}>
                <Grid size={col3}>
                    <ActionCard
                        icon={<TruckIcon color="action" sx={{fontSize: '48px'}} />}
                        title={t("import/transport")}
                        onClick={() => handleSelectCategory('transport')}
                    />
                </Grid>
                <Grid size={col3}>
                    <ActionCard
                        icon={<WarehouseIcon color="action" sx={{fontSize: '48px'}} />}
                        title={t("import/consumption")}
                        onClick={() => handleSelectCategory('consumption')}
                    />
                </Grid>
            </Grid>
        </>
        
    )
}